import React from "react";
import { Button, Typography } from "@material-ui/core";

interface IProps {
  clickFn: () => void;
}

const BlueButton: React.FC<IProps> = ({ clickFn }: IProps) => {
  return (
    <Button
      onClick={() => clickFn()}
      variant={"contained"}
      style={{ height: "40px", backgroundColor: "#3db0e2", color: "#fff" }}
    >
      <Typography variant={"button"}>Wyczyść</Typography>
    </Button>
  );
};

export default BlueButton;
